import React, { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import WhatsApp from "../../../assets/images/socials/whatsapp.svg";
import Instagram from "../../../assets/images/socials/instagram.svg";
import FACEBOOK from "../../../assets/images/socials/facebook.svg";
import Web from "../../../assets/images/socials/web.svg";
import Facebook from "./facebook";
import restService from "../../../restService";
import UserContext from "../../../contexts/UserContext";
import CampaignContext from "../../../contexts/CampaignContext";

const SocialChannels = () => {
  const [user] = useContext(UserContext);
  const [campaign] = useContext(CampaignContext);
  const [messengerData, setMessengerData] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const channels = [
    {
      name: "Twitter Campaigns",
      icon: "https://i.ibb.co/556vKRM/twitter.png",
      to: "/social-channels/twitter-campaigns",
    },
    {
      name: "WhatsApp Campaigns",
      icon: WhatsApp,
      to: "/social-channels/twitter-campaigns",
    },
    {
      name: "Instagram Campaigns",
      icon: Instagram,
      to: "/social-channels/twitter-campaigns",
    },
    {
      name: "Facebook Campaigns",
      icon: FACEBOOK,
      to: "/social-channels/twitter-campaigns",
    },
    {
      name: "Web Campaigns",
      icon: Web,
      to: "/social-channels/twitter-campaigns",
    },
  ];

  async function fetchSettings() {
    setIsLoading(true);
    try {
      const { data } =
        await restService.ChannelManagerServices.fetchConnectedChannels(
          campaign?.id,
          user?.accessToken
        );

      const messenger_channel =
        (data?.data || [])?.find(
          (x) => x?.channelType?.toLowerCase() === "messenger"
        ) || null;

      setMessengerData(messenger_channel);

      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    fetchSettings();
  }, []);

  return (
    <div className="h-full px-4 md:px-8 w-full">
      <h1 className="text-2xl leading-9">Social Channels</h1>

      {/* All Channles */}
      <div className="grid mt-8 gap-5  lg:grid-cols-4 md:grid-cols-3 grid-cols-2 ">
        <Facebook
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          fetchSettings={fetchSettings}
          messengerData={messengerData}
        />

        {/* {channels.map((channel, index) => (
          <Link key={index} to={channel.to}>
            <div className="shadow bg-white py-9 h-[15rem] px-10 w-full flex flex-col items-center">
              <img src={channel.icon} alt="" />
              <p className=" mt-9 text-[#626262] text-center text-xs md:text-sm w-full">
                {channel.name}
              </p>
            </div>
          </Link>
        ))} */}
      </div>
    </div>
  );
};

export default SocialChannels;
